<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Search Results for &quot;{{ query }}&quot;</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-10 is-offset-1">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body" style="min-height: 300px;">
                <div v-if="results.length === 0" class="has-text-centered">
                  <p>No results found for this phrase.</p>
                </div>
                <div v-if="results.length > 0">
                  <div v-for="result in results" :key="result.id">
                    <div
                      v-if="result.type === 'series' || result.type === 'movie'"
                    >
                      <div class="columns">
                        <div class="column is-2">
                          <figure
                            v-if="
                              result.mediadata && result.mediadata.titleImage
                            "
                          >
                            <router-link
                              :to="{
                                name: 'MediaDetail',
                                params: { id: result.id }
                              }"
                            >
                              <img
                                :src="thumbnail(result.mediadata.titleImage)"
                              />
                            </router-link>
                          </figure>
                        </div>
                        <div class="column is-10">
                          <b-tag
                            type="is-primary"
                            class="is-uppercase has-text-weight-bold"
                            >{{ result.type }}</b-tag
                          >
                          <router-link
                            :to="{
                              name: 'MediaDetail',
                              params: { id: result.id }
                            }"
                          >
                            <h3 class="title">{{ result.value }}</h3>
                          </router-link>
                          <p
                            v-if="result.description"
                            class="has-margin-top-15"
                          >
                            {{ result.description }}
                          </p>
                          <b-button
                            class="has-margin-right-10 has-margin-top-15"
                            :to="{
                              name: 'MediaDetail',
                              params: { id: result.id }
                            }"
                            tag="router-link"
                          >
                            More Info
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="columns">
                        <div class="column is-2"></div>
                        <div class="column is-10">
                          <b-tag
                            type="is-primary"
                            class="is-uppercase has-text-weight-bold"
                            >{{ result.type }}</b-tag
                          >
                          <router-link
                            :to="{
                              name: 'Metadata',
                              params: { type: result.type, id: result.id }
                            }"
                          >
                            <h3 class="title">{{ result.value }}</h3>
                          </router-link>
                          <b-button
                            class="has-margin-right-10 has-margin-top-15"
                            :to="{
                              name: 'Metadata',
                              params: { id: result.id }
                            }"
                            tag="router-link"
                          >
                            More Info
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import MediaApi from '@/api/media'
import Utils from '@/mixins/utils'

export default {
  name: 'Cart',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Search'
  },
  mixins: [Utils],
  data() {
    return {
      initialized: false,
      query: {},
      results: []
    }
  },
  watch: {
    $route() {
      this.search()
    }
  },
  async created() {
    this.search()
  },
  methods: {
    async search() {
      this.query = this.$route.query.q
      let results = await MediaApi.search(this.query)
      if (results && results.length > 0) {
        results.forEach(item => {
          if (item.type === 'movie' || item.type === 'series') {
            if (item.mediadata && item.mediadata !== '') {
              item.mediadata = JSON.parse(item.mediadata)
            }
          }
        })
      }
      this.results = results
      this.initialized = true
    }
  }
}
</script>
